<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_info">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="serviceobjecttype_keyno" [ttModel]="menu.serviceobjecttype_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="serviceobjecttype_name" [ttModel]="menu.serviceobjecttype_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'serviceobjecttypemenu_edit'" [ttGoto]="'serviceobjecttype'" [ttGotoParms]="{ serviceobjecttype_keyno: menu.serviceobjecttype_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'serviceobjecttypemenu_intervals'" [ttBadge]="menu.nbr_of_serviceobjecttypeints" [ttGoto]="'serviceobjecttypeints'" [ttGotoParms]="{ serviceobjecttype_keyno: menu.serviceobjecttype_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_info" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-input class="col-xs-12 sp-0" tt-label="serviceobjecttype_keyno" tt-model="vm.model.menu.serviceobjecttype_keyno" tt-change="vm.model.menu.serviceobjecttype_keyno = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="serviceobjecttype_name" tt-model="vm.model.menu.serviceobjecttype_name" tt-change="vm.model.menu.serviceobjecttype_name = $value" tt-readonly="true"></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_functions" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="serviceobjecttypemenu_edit" tt-goto="serviceobjecttype" tt-goto-parms="{ serviceobjecttype_keyno: vm.model.menu.serviceobjecttype_keyno }" tt-text-align="left"></tt-button-goto>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="serviceobjecttypemenu_intervals" tt-badge="{{vm.model.menu.nbr_of_serviceobjecttypeints}}" tt-goto="serviceobjecttypeints" tt-goto-parms="{ serviceobjecttype_keyno: vm.model.menu.serviceobjecttype_keyno }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>-->
